module.exports = __webpack_public_path__ + "media/dog-weight/dachshund-white-dec40485.svg";